import List from './list'
import ListItem from './list-item'

List.Item = ListItem

export default List



// WEBPACK FOOTER //
// ./src/components/ui/list/index.js